import Page from './Page.tsx'
import { Button } from "@mui/material"
import { context } from "../../index.js"
import { observer } from "mobx-react-lite"
import PageFinal from "./PageFinal.tsx"
import PreviousAnswers from './PreviousAnswers.tsx'
import { checkJwtRole } from '../../misc/utils.ts'


export default observer(function Questionnaire () {

    const questionnaireTitle = context.getQuestionnaireTitle()

    return (
        <div className={context.submitting ? "questionnaire disabled" : "questionnaire"}>
            <small style={{color: "grey"}}>{questionnaireTitle}</small>
            <QuestionnaireBody />
        </div>
    )
})


const QuestionnaireBody = observer(() => {

    const { submitting, getPage, showPreviousAnswers, questionnaire, showSettings } = context

    const page = getPage()

    if (showPreviousAnswers) {
        return (
            <div className="questionnaire-page">
                <h2>Your Answers</h2>
                <p>These are the answers provided by <b>{context.respondentEmail}</b> in response to this '{questionnaire.template.displayName}' questionnaire.</p>
                <PreviousAnswers />
            </div>
        )
    }
    
    if (page) {
        
        // Use show_settings to disable settings, don't hide them completely
        const disabled = (!checkJwtRole("show_settings") && showSettings) || submitting
        
        return (
            <div className={disabled ? "disabled" : ""}>
                <Page page={page} />
            </div>
        )
    }

    return <PageFinal />
})